type CheckWidthOptions = {
  rootSelector?: string;
  itemSelector?: string;
  className?: string;
  offset?: number;
};

export function initCheckWidth({
  rootSelector = '.js-box-checking-width',
  itemSelector = '.js-box-checking-width-el',
  className = 'js-right',
  offset = 450
}: CheckWidthOptions = {}): void {
  const containers = document.querySelectorAll<HTMLElement>(rootSelector);
  if (!containers.length) return;

  const update = (): void => {
    containers.forEach(container => {
      const items = container.querySelectorAll<HTMLElement>(itemSelector);
      if (!items.length) return;

      const containerRect = container.getBoundingClientRect();
      const containerRight = containerRect.right;

      items.forEach(item => {
        const itemRect = item.getBoundingClientRect();
        const distanceToRight = containerRight - itemRect.right;

        if (distanceToRight <= offset) {
          item.classList.add(className);
        } else {
          item.classList.remove(className);
        }
      });
    });
  };

  // первичный запуск
  update();

  // resize (с небольшой оптимизацией)
  let rafId: number | null = null;

  const onResize = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(update);
  };

  window.addEventListener('resize', onResize);
}